import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'CuttingItem',
    column_type: 'id',
    label_key_path: 'cuttingItem.id',
  },
  created_at: {
    model_name: 'CuttingItem',
    column_type: 'datetime',
    label_key_path: 'cuttingItem.createdAt',
  },
  updated_at: {
    model_name: 'CuttingItem',
    column_type: 'datetime',
    label_key_path: 'cuttingItem.updatedAt',
  },
  cutting_record: {
    model_name: 'CuttingItem',
    column_type: 'belongs_to',
    label_key_path: 'cuttingItem.cuttingRecord',
    extra: {
      association_name: 'cutting_record',
      model_name: 'CuttingRecord',
      foreign_key: 'cutting_record_id',
      display_column: 'id',
    },
  },
  cutting_record_id: {
    model_name: 'CuttingItem',
    column_type: 'belongs_to',
    label_key_path: 'cuttingItem.cuttingRecord',
    extra: {
      association_name: 'cutting_record',
      model_name: 'CuttingRecord',
      foreign_key: 'cutting_record_id',
      display_column: 'id',
    },
  },
  line_item: {
    model_name: 'CuttingItem',
    column_type: 'belongs_to',
    label_key_path: 'cuttingItem.lineItem',
    extra: {
      association_name: 'line_item',
      model_name: 'LineItem',
      foreign_key: 'line_item_id',
      display_column: 'id',
    },
  },
  line_item_id: {
    model_name: 'CuttingItem',
    column_type: 'belongs_to',
    label_key_path: 'cuttingItem.lineItem',
    extra: {
      association_name: 'line_item',
      model_name: 'LineItem',
      foreign_key: 'line_item_id',
      display_column: 'id',
    },
  },
  quantity: {
    model_name: 'CuttingItem',
    column_type: 'integer',
    label_key_path: 'cuttingItem.quantity',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
